module.exports = __webpack_public_path__ + "static/markus-spiske-2VMcpbUR6w8-unsplash-fed4d5f27c453bb571f385ac09ab57a3.jpg";